import type { CreateWorkflowField, Field } from "~/types/api";

export type PathField = Field | CreateWorkflowField;

export type PathFieldOption = { label: string; value: number };

export type PathFieldMeta = {
  outputOptions: PathFieldOption[];
  defaultOutputFieldId: number | null;
};

export const getPathFieldMeta = (pathFields: PathField[] = []): PathFieldMeta => {
  const outputOptions: PathFieldOption[] = pathFields.map((field) => ({
    label: field.name,
    value: field.id,
  }));

  const defaultOutputFieldId = pathFields[0]?.id ?? null;

  return {
    outputOptions,
    defaultOutputFieldId,
  };
};
